import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  IconButton,
  Typography,
  Box,
  CircularProgress,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const ManualListDialog = ({ open, onClose }) => {
  const [manuals, setManuals] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setLoading(true);
      fetch(`${process.env.PUBLIC_URL}/Manual/manifest.json`)
        .then(res => res.json())
        .then(data => setManuals(data))
        .catch(() => setManuals([]))
        .finally(() => setLoading(false));
    }
  }, [open]);

  const handleOpen = (path) => {
    window.open(`${process.env.PUBLIC_URL}${path}`, '_blank');
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <MenuBookIcon color="primary" />
          <Typography variant="h6" component="span">User Manuals</Typography>
        </Box>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers sx={{ p: 0 }}>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress size={32} />
          </Box>
        ) : manuals.length > 0 ? (
          <List disablePadding>
            {manuals.map((manual) => (
              <ListItemButton key={manual.id} onClick={() => handleOpen(manual.path)}>
                <ListItemIcon sx={{ minWidth: 40 }}>
                  <MenuBookIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText
                  primary={manual.title}
                  secondary={manual.discipline}
                />
                <OpenInNewIcon fontSize="small" color="action" />
              </ListItemButton>
            ))}
          </List>
        ) : (
          <Box sx={{ py: 4, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              No manuals available.
            </Typography>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ManualListDialog;
